// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailFilledSvg from "@ant-design/icons-svg/es/asn/MailFilled";
import AntdIcon from '../components/AntdIcon';

var MailFilled = function MailFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailFilledSvg
  }));
};

MailFilled.displayName = 'MailFilled';
export default React.forwardRef(MailFilled);